import React from 'react'
import { Spinner } from 'react-bootstrap';
import Button from '../StyledComponents/Button'
import ATagButton from '../StyledComponents/ATagButton';

class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false, tapped: false };
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  
    componentDidCatch(error, errorInfo) {
      // You can also log the error to an error reporting service
      //logErrorToMyService(error, errorInfo);
      console.log(error, errorInfo)
    }
  
    reloadPage =e=>
    {
        this.setState({tapped: true});
        window.location.reload(true);
    }

    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return (
            <div style={{padding:'20px', height:'100vh', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', textAlign:'center'}}>
                <h3 style={{marginBottom:'30px'}}>Something went wrong.</h3>
                {this.state.tapped ? 
                    <Spinner variant="primary" animation="border"/>
                    :
                    <div style={{display:'flex', flexDirection:'column'}}>

                      <ATagButton
                      block
                      primary
                      shadow
                      href="mailto:team@bigtinysound.com">
                        Let us know about your issue
                      </ATagButton>

                      <Button
                      style={{marginTop: '15px'}} 
                      onClick={this.reloadPage}>
                        Refresh the page
                      </Button>
                    </div>
                }
            </div>
        );
      }
  
      return this.props.children; 
    }
}
export default ErrorBoundary